"use client";

import OverlayReady from "@/components/common/OverlayReady";

export default function Template({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      <OverlayReady />
    </>
  );
}


